/**
 *  getMaterialUsage action creators
 */
import {RECEIVED_MATERIAL_USAGE_INFO, ERROR_ON_GETTING_MATERIAL_USAGE, START_FETCHING_MATERIAL_USAGE} from "./types";
import {backendDomain} from "../modules/configs";
import axios from 'axios'

export const getMaterialUsage = (userId) => dispatch => {
  dispatch({ type: START_FETCHING_MATERIAL_USAGE });
  const materialUsageEndpoint = `${backendDomain}/query/cumulative`;
  axios.get(materialUsageEndpoint, { headers: { Authorization: `Bearer ${localStorage.access_token}` } })
    .then((res) => dispatch(getMaterialUsageDone(res.data)))
    .catch((error) => dispatch(getMaterialUsageError(error)));
}

const getMaterialUsageDone = (totalMaterialUsage) => ({
  type: RECEIVED_MATERIAL_USAGE_INFO,
  payload: { totalMaterialUsage }
})

export const getMaterialUsageError = (error) => ({
  type: ERROR_ON_GETTING_MATERIAL_USAGE,
  payload: { error }
})


// WEBPACK FOOTER //
// ./src/actions/getMaterialUsage.js